export const isLocalhost = (hostname = window.location.hostname) =>
  ['localhost', '127.0.0.1', '', '::1'].includes(hostname);

export const isLocalOrTestHost = (hostname = window.location.hostname) =>
  isLocalhost(hostname) || hostname.includes('test-tamagotchi');
